<template>
  <div class="dashboard">
    <h1>{{greetingText}} {{session.name}}!</h1>
    <p>You have watched {{videosWatched}} video(s)</p>
  </div>
</template>

<script>
export default {
  props: {
    session: Object
  },
  computed: {
    greetingText: function() {
      const today = new Date()
      const curHr = today.getHours()

      if (curHr < 12) return 'Good morning';
      else if (curHr < 18) return 'Good afternoon';
      else return 'Good evening';
    },
    videosWatched: function() {
      const parsedVideosWatched = JSON.parse(this.session.watchedVideos);

      return parsedVideosWatched.length;
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue